import React, { useEffect } from 'react';

export const WIDGETS_LOADED : string[] = [];

export const useRefListener = <T>(eventName: string, onChange: (item: T) => void) => {
  const ref = React.useRef<HTMLInputElement | null>(null);
  const mapToEventValue: (event: any) => T = (event) => event || [];

  const onSelectionChanged = (event: any) => {
    onChange(mapToEventValue(event));
  };

  React.useEffect(() => {
    ref?.current?.addEventListener(eventName, onSelectionChanged);
    return () => ref?.current?.removeEventListener(eventName, onSelectionChanged);
  }, [onChange]);

  return ref;
};

export const useWidget = (widgetUrl: string) => {
  useEffect(() => {
    if(widgetUrl) {
      const widgetSrc = `${widgetUrl}.js`;
      if (WIDGETS_LOADED.indexOf(widgetSrc) === -1) {
        WIDGETS_LOADED.push(widgetSrc);
        document.body.appendChild(createScriptElement(widgetSrc));
      }
    }
  }, [widgetUrl]);
};

const createScriptElement = (scriptUrl: string) => {
  const preloadLink = document.createElement('link');
  preloadLink.href = scriptUrl;
  preloadLink.rel = 'prefetch';
  preloadLink.as = 'script';
  document.head.appendChild(preloadLink);

  const script = document.createElement('script');
  script.src = scriptUrl;
  script.type = 'text/javascript';
  script.async = true;
  return script;
};